import { Gradient } from 'utils/types';
import { StyledMainProduct } from './styles';

export const MainProduct = ({
  product = '',
  traits = [],
  backgroundSrc = '',
  backgroundColor,
}: {
  product?: string;
  traits?: {
    image: string;
  }[];
  backgroundSrc?: string;
  backgroundColor: Gradient;
}) => {
  return (
    <StyledMainProduct
      backgroundColor={backgroundColor}
      isMainProduct={!!product}
      className="mainProduct"
    >
      {product ? (
        <div className="product">
          <img className="image" src={product} alt="product" />
          {traits.length > 0 && (
            <div className="traits">
              {traits.map(({ image }, index) => (
                <img className="trait" src={image} alt="trait" key={index} />
              ))}
            </div>
          )}
        </div>
      ) : (
        <>
          {backgroundSrc && (
            <img
              className="backgroundSrc"
              src={backgroundSrc}
              alt="background"
            />
          )}
        </>
      )}
    </StyledMainProduct>
  );
};
